<pagination>
  <div class="pagination">
    <div onclick="{ back }" class="page-item { props.page == 1 ? 'disabled' : '' }">&laquo;</div>
    <div each="{ (v, i) in new Array(props.count) }" class="page-item { props.page == i + 1 ? 'active' : '' }"
      key="{ i }" data-item="{ i }" onclick="{ onPageClick }">{ i + 1 }</div>
    <div onclick="{ next }" class="page-item { props.page == props.count ? 'disabled' : '' }">&raquo;</div>
  </div>
  <script>
    export default {
      back() {
        if (this.props.page == 1) {
          return;
        }
        this.changePage(Number(this.props.page) - 1);
      },

      next() {
        if (this.props.page == this.props.count) {
          return;
        }
        this.changePage(Number(this.props.page) + 1);
      },

      onPageClick(e) {
        const page = Number(e.target.dataset.item) + 1;
        this.changePage(page);
      },

      changePage(page) {
        this.props.change(page);
        this.update();
      },
    };
  </script>
  <style>
    .pagination {
      display: flex;
    }

    .page-item {
      color: black;
      padding: 6px 14px;
      text-decoration: none;
      transition: background-color .3s;
      border: 1px solid #ddd;
      background-color: rgb(255, 255, 255);
      cursor: pointer;
    }

    .page-item.active {
      background-color: #3f51b5;
      color: white;
      border: 1px solid #3f51b5;
    }

    .page-item:hover:not(.active) {
      background-color: #ddd;
    }

    .page-item:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    .page-item:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }

    .page-item.disabled {
      background-color: #ddd;
      cursor: not-allowed;
    }
  </style>
</pagination>